import { createIncludedLookup } from '../../../schema/validation/createIncludedLookup'
import { type CacheUpdateFn } from '../../../util/buildQueryHelpers'
import { type EntityWorkflowsDocument, type WorkflowEntityType } from '../types'

/**
 * Replaces the workflows of the given blocks or moments with the incoming
 * ones. An entity that has no incoming workflow loses its cached one. The
 * contexts and stages of removed workflows stay in `included`.
 */
export const replaceEntityWorkflows =
  (
    entityType: WorkflowEntityType,
    entityIds: string[],
    incoming: EntityWorkflowsDocument
  ): CacheUpdateFn<EntityWorkflowsDocument> =>
  (draft) => {
    const replacedIds = new Set(entityIds)
    const findIncluded = createIncludedLookup(draft.included, 'V3')

    draft.data = draft.data.filter((workflow) => {
      const entityId = findIncluded(
        'workflow_context',
        workflow.relationships.context.data?.id
      )?.relationships[entityType].data?.id
      return entityId === undefined || !replacedIds.has(entityId)
    })
    draft.data.push(...incoming.data)

    const includedByKey = new Map(
      (draft.included ?? []).map((resource) => [
        `${resource.type}:${resource.id}`,
        resource,
      ])
    )
    incoming.included?.forEach((resource) =>
      includedByKey.set(`${resource.type}:${resource.id}`, resource)
    )
    draft.included = [...includedByKey.values()]

    return draft
  }
